<template>
  <table class="info info--importdata">
    <tbody>
      <tr
        v-for="(item, itemIndex) in list"
        :key="itemIndex"
      >
        <td>{{ item }}</td>
        <td class="textRight">
          <router-link
            class="routeOfStatus__link highlight"
            :to="{ name: 'route-of-administation' }"
          >
            Åben Administrationsveje
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
    name: 'ImportRouteOfAdministrationList',
    props: {
        list: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>
.textRight {
    text-align: right;
}
</style>
